export const NZ_LOCALE = 'en-NZ';
